<template>
  <div
    class="task-status_item"
    :class="(hide)? 'list-is-hide':''"
  >
    <div class="task-status_title">
      <span class="mdi mdi-border-color" />
      <b
        class="task-status_title_link"
        @click.stop="toggleTaskList"
      > {{ server.ip }}</b>
    </div>
    <ul class="task-status_list">
      <li
        v-for="(port,key) in server.ports"
        :key="key"
        class="task-status_list_item"
      >
        <span v-if="port.port">port: <a class="task-status_list_link"> {{port.port}}({{type(port.type)}})</a></span>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: 'ServerPorts',
  components: {
  },
  props: ['server'],
  data () {
    return { hide: true }
  },
  methods: {
    toggleTaskList () {
      this.hide = !this.hide
    },
    type (type) {
      let types = {1: 'multilink', 2: 'stcp'}
      return types[type]
    }
  }
}
</script>

<style scoped>

</style>
